// Landing after sign-in: a pending invitation, the last organisation used, else the first, else
// onboarding. Also resolves alarm links from notifications (/alarms/:id), which do not name the
// organisation.

import { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router';
import { lastOrg, useUser } from '../components/Shell.tsx';
import { pendingInvitation } from './auth/AuthPages.tsx';
import { Alert, Spinner } from '../components/ui.tsx';
import { useI18n } from '../i18n/index.ts';
import { api } from '../lib/api.ts';

export function Home() {
  const me = useUser();
  // Back from an invitation's sign-up detour (its confirmation link opened another tab).
  if (pendingInvitation()) return <Navigate to="/invitations/accept" replace />;
  const last = lastOrg();
  if (me.organisations.length === 0) return <Navigate to="/onboarding" replace />;
  const org = me.organisations.find((o) => o.org_id === last) ?? me.organisations[0]!;
  return <Navigate to={`/o/${org.org_id}`} replace />;
}

export function AlarmLink() {
  const { alarmId = '' } = useParams();
  const me = useUser();
  const navigate = useNavigate();
  const { t } = useI18n();
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      const last = lastOrg();
      const orgs = [...me.organisations].sort((a, b) => Number(b.org_id === last) - Number(a.org_id === last));
      for (const o of orgs) {
        try {
          await api(`/orgs/${o.org_id}/alarms/${alarmId}`);
          if (!cancelled) navigate(`/o/${o.org_id}/alarms/${alarmId}`, { replace: true });
          return;
        } catch {
          // not in this organisation
        }
      }
      if (!cancelled) setMissing(true);
    })();
    return () => { cancelled = true; };
  }, [alarmId, me.organisations, navigate]);
  if (!missing) return <div className="flex min-h-screen items-center justify-center"><Spinner /></div>;
  return (
    <div className="mx-auto max-w-md p-8">
      <Alert tone="amber" title={t('alarms.notFound')}>{t('alarms.notFoundBody')}</Alert>
      <Link to="/" className="mt-4 inline-block text-sm text-brand-600 hover:underline">{t('common.continue')}</Link>
    </div>
  );
}
